import ContactForm from "../components/ContactForm";

export default function Contact() {
  return (
    <div className="p-6 max-w-4xl mx-auto">

      <h1 className="text-4xl font-bold mb-4">Contact Us</h1>
      <p className="text-gray-600 mb-8">
        Reach out for engineering, fabrication, or IT service requirements.
      </p>

      <div className="grid md:grid-cols-2 gap-6">

        {/* Contact Info */}
        <div className="p-6 bg-white shadow rounded">
          <h2 className="text-xl font-semibold mb-2">Contact Information</h2>

          <p className="text-gray-600">📍 Bangalore / Vijayawada</p>
          <p className="text-gray-600">📧 your-email@example.com</p>
          <p className="text-gray-600">📞 +91-XXXXXXXXXX</p>
        </div>

        {/* Form */}
        <ContactForm />

      </div>

    </div>
  );
}
